import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Spinner.module.css';
var Spinner = function (_a) {
    var size = _a.size, color = _a.color, className = _a.className;
    var style = size || color
        ? {
            height: size,
            width: size,
            'border-color': color,
            'border-right-color': 'transparent',
        }
        : undefined;
    return _jsx("div", { className: [styles.spinnerBorder, className].join(' '), style: style }, void 0);
};
export default Spinner;
